import React from "react";
import classNames from "classnames";
import "./Typography.css";

const variantsMapping: any = {
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4",
  h5: "h5",
  h6: "h6",
  subheading1: "h6",
  subheading2: "h6",
  body1: "p",
  body2: "p",
  inherit: "span",
  button: "span",
  caption: "span",
  overline: "span",
};

interface ITypography {
  variant?: string;
  align?: string;
  color?: string;
  component?: string;
  gutterBottom?: boolean;
  children?: any;
  style?: any;
  onClick?: any;
}

const Typography = ({ variant, color, children, align, ...props }: ITypography) => {
  const Component = props.component ? props.component : variant ? variantsMapping[variant] : "p";

  return (
    <Component
      className={classNames({
        [`typography--variant-${variant ? variant : "body1"}`]: variant ? variant : "body1",
        [`typography--color-${color}`]: color,
        [`typography-gutterBottom`]: props.gutterBottom,
        [`typography--Root`]: props,
      })}
      style={{ ...props.style, ...(align && {textAlign: align}) }}
      {...props}
    >
      {children}
    </Component>
  );
};

export default Typography;